import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SidebarModule } from 'primeng/sidebar';
import { CalendarModule } from 'primeng/calendar';
import { LayoutService } from './service/app.layout.service';

@Component({
    selector: 'app-profilemenu',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        SidebarModule,
        CalendarModule
    ],
    templateUrl: './app.profilesidebar.component.html'
})
export class AppProfileSidebarComponent {
    date: Date= new Date();
    constructor(public layoutService: LayoutService) { }

    get visible(): boolean {
        return this.layoutService.state.rightMenuActive;
    }

    set visible(_val: boolean) {
        this.layoutService.state.rightMenuActive = _val;
    }
}
